<div class="d-flex w-100 h-100">
    <div
        class="av-cell available fs-2 h-100 w-75 hover"
        *ngIf="roomCost > 0 && (+stay.adults <= +room.maxAdults && +stay.children <= +room.maxChildren)"
        (click)="viewRoom()">
        {{roomCost | removePence}}
    </div>
    <div
        class="av-cell available fs-2 h-100 w-25 hover"
        *ngIf="roomCost > 0 && (+stay.adults <= +room.maxAdults && +stay.children <= +room.maxChildren)"
        (click)="viewRoomRate()">
        <i class="fa fa-info-circle" style="font-size: 16px; margin-top: 1px; color: white; cursor: pointer;"></i>

    </div>

    <div
        class="av-cell fs-2 h-100 w-75" style="background-color: orange; color: white; font-size: 10px"
        *ngIf="roomCost > 0 && (+stay.adults > +room.maxAdults)">
        !Max adults
    </div>
    <ng-container>

    </ng-container>
    <div
        class="av-cell fs-2 h-100 w-75" style="background-color: orange; color: white; font-size: 10px"
        *ngIf="roomCost > 0 && (+stay.children > +room.maxChildren)">
        !Max children
    </div>

    <div
        class="av-cell"
        *ngIf="roomCost === 0">

    </div>

</div>

